<template>
    <Loader v-if="loader" />
    <div class="table-container">
        <div class="card">
            <Toolbar>
                <template #start>
                    <div class="formgrid grid ">
                        <div class="field col-8 md:col-8">
                            <label>Seleziona il mese</label>
                            <Calendar v-model="mese_riferimento" class="inputfield w-full" :showIcon="true" view="month"
                                dateFormat="mm yy" :manualInput="false" />
                        </div>
                        <div class="field col-4 md:col-4 flex align-items-end">
                            <Button label="Cerca" @click="searchData" icon="pi pi-search" iconPos="left"
                                class="w-full" />
                        </div>
                    </div>
                </template>
                <template #end>
                    <Button label="Esporta" icon="pi pi-download" class="p-button-secondary"
                        @click="exportCSV($event)" />
                </template>
            </Toolbar>
            <DataTable ref="dt" :value="items" :paginator="true" :rows="30" :filters="filters"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]" responsiveLayout="scroll"
                currentPageReportTemplate="{first} a {last} di {totalRecords}">
                <template #header>
                    <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search" />
                            <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                        </span>
                    </div>
                </template>
                <template #empty>
                    <div class="text-center">Nessun dato trovato per questo mese.</div>
                </template>
                <Column field="data_emissione" header="Data Emissione" :sortable="true"></Column>
                <Column field="code" header="Pod" :sortable="true"></Column>
                <Column field="numero" header="Numero Fattura" :sortable="true"></Column>
                <Column field="energia" header="Energia" :sortable="true"></Column>
                <Column field="tensione" header="Cluster" :sortable="true"></Column>
                <Column field="consumo" header="Consumo" :sortable="true"></Column>
            </DataTable>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { FilterMatchMode } from 'primevue/api';
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance } from 'vue';
import Loader from '@/components/Loader.vue'

export default {
    components: {
        Loader
    },
    setup() {
        const dt = ref();
        const loader = ref(false);
        const items = ref([]);
        const mese_riferimento = ref(new Date())
        const filters = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const service = new Service(self.$http, self.$eventBus)

        onMounted(() => {
            getData(mese_riferimento.value);
        })
        const getData = (date) => {
            date = moment(date).format('YYYY-MM-DD');
            loader.value = true;
            service.getReportPod(date).then((res) => {
                items.value = res.items
            }).finally(() => {
                loader.value = false;
            })
        }


        const searchData = () => {
            if (mese_riferimento.value) {
                let date = moment(mese_riferimento.value).format('YYYY-MM-DD');
                getData(date)
            }
        }

        const exportCSV = () => {
            dt.value.exportCSV();
        };


        return {
            items,
            loader,
            filters,
            mese_riferimento,
            searchData,
            exportCSV,
            dt
        }
    }
}
</script>
